import useSyncAllFilesFromLinkedEasyPVProject from '@/api/mutations/project/useSyncAllFilesFromLinkedEasyPVProject';
import useSyncAllFilesFromLinkedHeatpunkProject from '@/api/mutations/project/useSyncAllFilesFromLinkedHeatpunkProject';
import { Button, Modal, useToastContext } from '@payaca/ambrosia';
import { readableProjectIntegrationService } from '@payaca/helpers/projectIntegrationsHelper';
import { ProjectIntegrationService } from '@payaca/types/projectIntegrationTypes';
import { FC } from 'react';

type SyncFilesConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
} & SyncFilesConfirmationModalContentProps;
const SyncFilesConfirmationModal: FC<SyncFilesConfirmationModalProps> = (
  props
) => {
  const { isOpen, service, ...rest } = props;
  return (
    <Modal
      title={`Sync files from ${
        service ? readableProjectIntegrationService[service] : ''
      }`}
      isOpen={isOpen}
      {...rest}
    >
      <SyncFilesConfirmationModalContent service={service} {...rest} />
    </Modal>
  );
};

type SyncFilesConfirmationModalContentProps = {
  onClose?: () => void;
  service?: ProjectIntegrationService;
  projectId: string;
  projectIntegrationId?: string;
};
const SyncFilesConfirmationModalContent: FC<
  SyncFilesConfirmationModalContentProps
> = (props) => {
  const { onClose, service, projectId, projectIntegrationId } = props;
  const { pushInfo } = useToastContext();

  const {
    mutate: syncAllFilesFromLinkedEasyPVProject,
    isPending: isEasyPVPending,
  } = useSyncAllFilesFromLinkedEasyPVProject({
    projectId,
    options: {
      onSuccess: () => {
        onClose?.();
        pushInfo(`File sync started - we will notify you when it's complete.`);
      },
    },
  });
  const {
    mutate: syncAllFilesFromLinkedHeatpunkProject,
    isPending: isHeatpunkPending,
  } = useSyncAllFilesFromLinkedHeatpunkProject({
    projectId,
    options: {
      onSuccess: () => {
        onClose?.();
        pushInfo(`File sync started - we will notify you when it's complete.`);
      },
    },
  });

  const isPending = isEasyPVPending || isHeatpunkPending;

  return (
    <>
      <Modal.Body>
        <p>
          {`Are you sure you want to sync files to this project? This will replace any
            files that were previously synced from ${
              service ? readableProjectIntegrationService[service] : ''
            }.`}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button onClick={onClose} variant="secondary">
            Cancel
          </Button>
          <Button
            disabled={isPending}
            onClick={() => {
              if (!projectIntegrationId) return;
              if (service === 'EASY_PV') {
                syncAllFilesFromLinkedEasyPVProject({
                  publicId: projectIntegrationId,
                  projectId,
                });
              } else if (service === 'HEATPUNK') {
                syncAllFilesFromLinkedHeatpunkProject({
                  publicId: projectIntegrationId,
                  projectId,
                });
              }
            }}
          >
            Sync
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </>
  );
};

export default SyncFilesConfirmationModal;
